import React, { Component } from 'react'
import "../../assets/css/general.css";
import { connect } from 'react-redux';
import { APIData } from '../../constants/APIAdresses';
import DefaultFrame from '../../components/DefaultFrame';
import GenericTable from '../../components/GenericTable/GenericTable';
import { setConflictsTableData } from '../../redux/supportSlice';
import { ConflictDialog } from './ConflictDialog';
import { MenuItem, Select, FormControl, InputLabel, Box, RadioGroup, FormControlLabel, Radio, FormLabel } from '@mui/material';
export const CONFLICT_PARTICIPANT_TYPE = {
    USER: "1",
    SUPPORT: "2",
    SHOP: "3",
}
const columns = [
    {
        width: 50,
        label: 'ID',
        dataKey: 'id',
    },
    {
        label: 'Beschreibung',
        dataKey: 'description',
        // format: (value) => {s
        //     let index = Object.values(ROLES).findIndex(rVal => rVal.toString() === value.toString())
        //     return index != -1 ? Object.keys(ROLES)[index] : value;
        // }
    },
    { dataKey: 'createDate', label: 'Datum', width: 150, format: (value) => { return !isNaN(new Date(value)) ? new Date(value).toLocaleString('de', { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).replace(",", "") : "-" } },
    {
        label: 'Benutzer-ID',
        dataKey:'userId',
        width: 80
    },
    {
        label: 'Shop-ID',
        dataKey:'shopId',
        width: 80
    },
    {
        label: 'Bestell-ID',
        dataKey:'orderId',
        width: 80
    },
    {
        label: 'Sitzungs-ID',
        dataKey:'sessionId',
        width: 260
    },

]
const ENTITY_TYPE = {
    ADDRESS: 1
}

export class ConflictsView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dialogOpen: false,
            conflictData: null,
            statusFilter: '1', // Default to "Offene"
        };
    }

    getApiEndpoint = () => {
        const baseUrl = APIData.USER + "/conflicts/getPaged";
        const { statusFilter } = this.state;
        if (statusFilter === '0') return baseUrl; // "Alle"
        return `${baseUrl}?status=${statusFilter}`;
    };

    handleFilterChange = (event) => {
        this.setState({ statusFilter: event.target.value });
    };

    render() {
        const { dialogOpen, conflictData, statusFilter } = this.state;

        return (
            <>
                <Box sx={{ mb: 2 }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Status</FormLabel>
                        <RadioGroup
                            row
                            value={statusFilter}
                            onChange={this.handleFilterChange}
                            aria-label="Status"
                            name="status-filter"
                        >
                            <FormControlLabel value="0" control={<Radio />} label="Alle" />
                            <FormControlLabel value="1" control={<Radio />} label="Offene" />
                            <FormControlLabel value="2" control={<Radio />} label="Geschlossen" />
                        </RadioGroup>
                    </FormControl>
                </Box>

                <GenericTable
                    config={{ columns: [...columns] }}
                    apiEndPoint={this.getApiEndpoint()}
                    tableData={this.props.tableData}
                    defaultItemsPerPage={25}
                    setTableData={(data) => this.props.setTableData(data)}
                    onClickRow={(index) => {
                        this.setState({
                            dialogOpen: true,
                            conflictData: this.props.tableData[index],
                        });
                    }}
                    noAdd
                />

                <ConflictDialog
                    opened={dialogOpen}
                    data={conflictData}
                    close={() => this.setState({ dialogOpen: false })}
                />
            </>
        );
    }
}


function mapStateToProps(state) {
    return {
        tableData: state.support.conflictsTableData,
        role: state.permission.role
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setTableData: (data) => {
            dispatch(setConflictsTableData(data));
        },
    }
}
class defaultWrapper extends React.Component {
    render() {
        return (
            <DefaultFrame title="Konflikte">
                <ConflictsView {...this.props} />
            </DefaultFrame>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(defaultWrapper);
